import { Component, Input } from '@angular/core';
import { cardFooterStyles, CardFooterProps } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-card-footer',
  template: `
    <div [ngClass]="cardFooter">
      <kite-stack 
        [align]="align"
        [direction]="direction"
        [spacing]="spacing"
        [justify]="justify"
      >
        <ng-content></ng-content>
      </kite-stack>
    </div>
  `,
})
export class CardFooterComponent {
  /**
   * Css del componente
   */
   @Input() css: CardFooterProps['css'];
   /**
    * Alineación de flexbox
    */
   @Input() align: CardFooterProps['align'];
   /**
    * Dirección de flexbox
    */
   @Input() direction: CardFooterProps['direction'] = 'column';
   /**
    * Espaciado entre componentes
    */
   @Input() spacing: CardFooterProps['spacing'] = 'xs';
 
   /**
    * Justify entre componentes
    */
   @Input() justify: CardFooterProps['justify'];

  public get cardFooter(): string[] {
    return [
      cardFooterStyles({ css: this.css }).className,
    ];
  }
}